module.exports = __webpack_public_path__ + "img/dots-vertical-blk.17eeb9c3.svg";